<template>
    <AdminTrackPayment></AdminTrackPayment>
</template>
<script>
    import AdminTrackPayment from '@/components/AdminTrackPaymentLiquidation.vue'
    export default {
        name: 'admin-track-payment',
        components: {
            AdminTrackPayment
        }
    }
</script>